import { TDeviceType } from '@cian/ui-kit';
import clsx from 'clsx';

import * as styles from './styles.css';

interface IStepsProps {
  children: React.ReactNode;
  device: TDeviceType;
}

export const Steps: React.FC<IStepsProps> = ({ children, device }) => {
  return <div className={clsx(styles['container'], styles[device])}>{children}</div>;
};
